import React from "react";
import { Tooltip as MuiTooltip } from "@mui/material";

/**
 * Brand-styled tooltip — thin wrapper over MUI Tooltip with the navy/white
 * brand look. Used by the dashboard's §10 placeholder treatments.
 *
 * Props: title, placement, children (the trigger), plus any MUI Tooltip prop.
 */
const TOOLTIP_SX = {
  fontFamily: "var(--font-body, 'Helvetica Neue', Arial, sans-serif)",
  fontSize: 12,
  fontWeight: 500,
  lineHeight: 1.4,
  background: "var(--color-navy-deep, #0f3460)",
  color: "#fff",
  borderRadius: "var(--radius-md, 8px)",
  padding: "7px 11px",
  boxShadow: "var(--shadow-pop, 0 8px 24px rgba(15,23,42,0.18))",
  maxWidth: 240,
};
const ARROW_SX = { color: "var(--color-navy-deep, #0f3460)" };

const Tooltip = ({ title, placement = "top", arrow = true, children, ...rest }) => (
  <MuiTooltip
    title={title}
    placement={placement}
    arrow={arrow}
    slotProps={{ tooltip: { sx: TOOLTIP_SX }, arrow: { sx: ARROW_SX } }}
    {...rest}
  >
    {children}
  </MuiTooltip>
);

export default Tooltip;
